import React from 'react';
import PropTypes from 'prop-types';
import { withAreaGetter } from 'providers/AreasConsumers';
import { ADMIN_LEASING_INCOME_SCHEMAS_READ, ADMIN_LEASING_INCOME_SCHEMAS_WRITE } from 'constants/rightsCodes';
import BrowserComponent from './BrowserComponent';
import HeaderPortal from 'components/layout/HeaderPortal';
import { areas } from 'constants/areas';
import Portal from 'utils/portal/Portal';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import IconButton from 'components/common/buttons/IconButton';
import PermissionCheck from 'components/common/PermissionCheck';
import StateHistoryComponent from './StateHistoryComponent';

const Route = ({ getElemByAreaKey }) => {
  const historyContext = useHistoryWithContext();

  return (
    <>
      <HeaderPortal />
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <PermissionCheck authorizationCode={ADMIN_LEASING_INCOME_SCHEMAS_WRITE} withForbiddenPage={false}>
          <IconButton onClick={() => historyContext.push(`/leasingIncomeSchemas/new`)} type='add' size='medium' iconFontSize='medium' />
        </PermissionCheck>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_LEASING_INCOME_SCHEMAS_READ}>
        <BrowserComponent />
        <StateHistoryComponent />
      </PermissionCheck>
    </>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
